import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Pin from "../ScrollPin/ScrollPin";
import Accordion from "../ScrollAccordion/ScrollAccordion";
import Scroller from "../../Scroller/Scroller";
import Router from "../../App/Router";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

// -----------------------------------------------------------
// Implementation off Pin & Accordion together

const ScrollSlider = {
    activeComponent: null,

    init() {
        this.el = $('[component="ScrollSlider"]');
        if (!this.el.length) return;

        this.headlines = this.el.find('h2');
        this.slides = this.el.find('[container]');
        this.urlx = this.el.attr('url');
        this.resize();
        $(window).on("load", (evt)=>{
            this.resize();
        })
    },

    resize() {
        if (!(this.el && this.el.length)) return;

        this.activeComponent && this.activeComponent.kill();

        if (window.innerWidth > window.innerHeight) {
            Pin.init(this.el);
            this.activeComponent = Pin;
        } else {
            Accordion.init(this.el);
            this.activeComponent = Accordion;
        }

        // this.bind();
    },

    bind() {
        this.headlines.click((evt) => {
            const url = $(evt.currentTarget).closest('[container]').attr('url')
            Router.route('/' + this.urlx + '/' + url);
        })
    },

    setByUrl(sectionUrl, url) {
        if(this.urlx !== sectionUrl) return;
        console.log('--- ScrollPin.setByUrl()', sectionUrl, url)
        const slide = this.slides.filter('[url="' + url + '"]');

        if (!slide || !slide.length) {
            console.log('fok')
            window.location.href = WEB_ROOT + '/404';
            return;
        }

        this.scrollTo(slide.offset().top);
    },

    scrollTo(top) {
        gsap.to(window, {
            duration: Scroller.animTime, scrollTo: {y: top}
        });
    },
};

export default ScrollSlider;